module.exports = __webpack_public_path__ + "img/bbLogo.9bed3762.png";